// extracted by mini-css-extract-plugin
export default {"ablaufSection":"ablauf-section_ablaufSection__3+0nO"};